import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export const LeadForm = () => {
  const { t } = useTranslation();

  useEffect(() => {
    // Evita duplicar el script si el componente se monta más de una vez
    const existing = document.querySelector(
      'script[src="https://link.jc-innovation.com/js/form_embed.js"]'
    );
    if (existing) return;

    const s = document.createElement("script");
    s.src = "https://link.jc-innovation.com/js/form_embed.js";
    s.async = true;
    document.body.appendChild(s);

    // No lo removemos en cleanup porque algunos widgets se “rompen” al desmontar
  }, []);

  return (
    <div className="wrapper_lead_form">
      <div className="content_lead_form">
        <h1 className="mt-1 fw_600 text-center">
          {t("¡Haz realidad tu evento ideal!")}
        </h1>

        <p className="text-center mb-4" style={{ fontSize: "1.15rem" }}>
          {t("Déjanos tus datos y te enviaremos una propuesta personalizada en menos de 24 horas.")}
        </p>

        {/* Contenedor para controlar el alto del iframe */}
        <div style={{ width: "100%", minHeight: 750 }}>
          <iframe
            src="https://link.jc-innovation.com/widget/form/q2fNHLw7x0RIU7ye4owF"
            style={{
              width: "100%",
              height: 750,
              border: "none",
              borderRadius: 4,
            }}
            id="inline-q2fNHLw7x0RIU7ye4owF"
            data-layout="{'id':'INLINE'}"
            data-trigger-type="alwaysShow"
            data-trigger-value=""
            data-activation-type="alwaysActivated"
            data-activation-value=""
            data-deactivation-type="neverDeactivate"
            data-deactivation-value=""
            data-form-name="B-008-CUF. Contact Us Form (on the website)"
            data-height="750"
            data-layout-iframe-id="inline-q2fNHLw7x0RIU7ye4owF"
            data-form-id="q2fNHLw7x0RIU7ye4owF"
            title="B-008-CUF. Contact Us Form (on the website)"
          />
        </div>

       
      </div>
    </div>
  );
};
